import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BroadcasterService} from '@core/broadcaster/broadcaster.service';

@Injectable()
export class ThingToggleEvent {
  constructor(private broadcaster: BroadcasterService) {}

  fire(key: string, areas: Array<any>, selectedAreas: Array<any>): void {
    this.broadcaster.broadcast(ThingToggleEvent, {
      key: key,
      areas: areas,
      selectedAreas: selectedAreas
    });
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(ThingToggleEvent);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/events/things/ThingToggleEvent.ts